import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { Reveal, SectionHeading } from "./ui";

export default function Partners() {
  const [brands, setBrands] = useState([]);
  useEffect(() => { api.get("/partners").then((r) => setBrands(r.data || [])); }, []);
  if (!brands.length) return null;
  const row = [...brands, ...brands];
  return (
    <section className="py-16 md:py-20 bg-white border-y border-line overflow-hidden">
      <div className="container-x">
        <Reveal className="mb-8"><SectionHeading center kicker="Brands We Work With" title="Our Valuable Partners" /></Reveal>
      </div>
      <div className="marquee group">
        <div className="marquee-track group-hover:[animation-play-state:paused]" data-testid="partners-carousel">
          {row.map((b, i) => (
            <div key={i} className="shrink-0 mx-5 md:mx-8 flex items-center justify-center min-w-[140px] h-[72px]">
              {b.logo_url
                ? <img src={b.logo_url} alt={b.name} className="max-h-[56px] max-w-[150px] w-auto object-contain" referrerPolicy="no-referrer" />
                : <span className="font-extrabold text-ink/80 text-lg tracking-tight whitespace-nowrap">{b.name}</span>}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
